
const curr_env = 'dev10'

const hosts = {
    dev1: {
        host: 'https://api1-staging.mryitao.cn',
        h5Host: 'https://h51-staging.mryitao.cn'
    },
    dev2: {
        host: 'https://api2-staging.mryitao.cn',
        h5Host: 'https://h52-staging.mryitao.cn'
    },
    dev3: {
        host: 'https://api3-staging.mryitao.cn',
        h5Host: 'https://h53-staging.mryitao.cn',
    },
    dev4: {
        host: 'https://api4-staging.mryitao.cn',
        h5Host: 'https://h54-staging.mryitao.cn'
    },
    dev5: {
        host: 'https://api5-staging.mryitao.cn',
        h5Host: 'https://h55-staging.mryitao.cn'
    },
    dev6: {
        host: 'https://api6-staging.mryitao.cn',
        h5Host: 'https://h56-staging.mryitao.cn'
    },
    dev7: {
        host: 'https://api7-staging.mryitao.cn',
        h5Host: 'https://h57-staging.mryitao.cn',
    },
    dev10: {
        host: 'https://api10-staging.mryitao.cn',
        h5Host: 'https://h510-staging.mryitao.cn',
    },
    qa1: {
        host: 'https://api1-qa.mryitao.cn',
        h5Host: 'https://h51-pre.mryitao.cn',
    },
    pre1: {
        host: 'https://api1-pre.mryitao.cn',
        h5Host: 'https://api.mryitao.cn'
    },
    prod: {
        host: 'https://api.mryitao.cn',
        h5Host: 'https://api.mryitao.cn'
    }
}

export default {
    getHosts: function() {
        return hosts[curr_env]
    }
}


// WEBPACK FOOTER //
// ./src/hosts.js